import React, { memo, ReactElement, ReactNode } from 'react';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from '../DataListItemRow.css';

export const Destination = memo(({ name, icon }: { name: string; icon?: ReactNode }): ReactElement => {
    return (
        <div className={styles.destination}>
            {icon && <div className={styles.destinationIcon}>{icon}</div>}
            <NameComponent name={name} showTooltip />
        </div>
    );
});

Destination.displayName = 'Destination';
